import { Currency, SearchResponse } from "interfaces/dataInterfaces"
import { coreApi } from "./coreApi"

export const currenciesApi = coreApi.injectEndpoints({
  endpoints: builder => ({
    getCurrencies: builder.query<SearchResponse<Currency>, { skip?: number; take?: number; query?: string }>({
      query: ({ skip, take, query }) => ({
        url: "Currencies/GetBySearch",
        params: { skip, take, search: query },
      }),
      providesTags: [{ type: "Currencies" as const, id: "LIST" }],
    }),
    addCurrency: builder.mutation<void, Partial<Currency>>({
      query: body => ({
        url: "Currencies/Post",
        method: "POST",
        body,
      }),
      invalidatesTags: [
        { type: "Currencies", id: "LIST" },
        { type: "Currencies", id: "LIST_BY_COUNTRY" },
      ],
    }),
    updateCurrency: builder.mutation<void, Currency>({
      query: body => ({
        url: "Currencies/Put",
        method: "PUT",
        body,
      }),
      invalidatesTags: [
        { type: "Currencies", id: "LIST" },
        { type: "Currencies", id: "LIST_BY_COUNTRY" },
      ],
    }),
    deleteCurrency: builder.mutation<void, number>({
      query: id => ({
        url: `Currencies/Delete`,
        method: "DELETE",
        params: { id },
      }),
      invalidatesTags: [
        { type: "Currencies", id: "LIST" },
        { type: "Currencies", id: "LIST_BY_COUNTRY" },
      ],
    }),
    getCurrenciesByCountry: builder.query<Currency[], number>({
      query: adm0Code => ({
        url: `Currencies/GetByCountry`,
        method: "GET",
        params: { adm0Code },
      }),
      providesTags: [{ type: "Currencies", id: "LIST_BY_COUNTRY" }],
    }),
  }),
})

export const {
  useGetCurrenciesQuery,
  useAddCurrencyMutation,
  useUpdateCurrencyMutation,
  useDeleteCurrencyMutation,
  useGetCurrenciesByCountryQuery,
} = currenciesApi
